import { ApolloClient, NormalizedCacheObject } from '@apollo/client'

import { uploadPublicFile } from '~/client/src/shared/services/publicFileUpload'

import { ImageUploader, LocalImageFile } from '../core/ports'
import { err, ok } from '../core/result'

// Adapts the app's signed-URL upload flow to the core's ImageUploader port.
// This flow is the only producer of URLs the chat server accepts: message
// attachments are validated against the tenant's own storage bucket.
export function createImageUploader(
  apolloClient: ApolloClient<NormalizedCacheObject>,
): ImageUploader {
  return async (file: LocalImageFile) => {
    try {
      const response = await fetch(file.uri)
      const blob = await response.blob()
      const { url } = await uploadPublicFile(
        apolloClient,
        new File([blob], file.fileName, { type: file.contentType }),
      )
      if (!url) {
        return err({
          kind: 'decode' as const,
          detail: 'upload returned no file URL',
        })
      }
      return ok(url)
    } catch (e) {
      return err({ kind: 'network' as const, message: String(e) })
    }
  }
}
